module.exports = __webpack_public_path__ + "Img_Neon_512px.png";